import * as types from '../actions/actionTypes';

const initialState = {
    campaigns: {
        loading: false,
        success: true,
        data: []
    },
    filters: {
        categoryId: '',
        locationId: '',
        year: ''
    },
    newCampaign: {
        loading: false,
        success: true,
        message: '',
        campaignId: ''
    },
    campaignDelete: {
        loading: false,
        success: true,
        message: ''
    }
}

export default (state = initialState, action) => {
    switch (action.type) {
        case types.START_GET_CAMPAIGNS:
            return Object.assign({}, state, { campaigns: { ...state.campaigns, success: true, loading: true } });
        case types.GET_CAMPAIGNS:
            return Object.assign({}, state, { campaigns: action.response });
            
        case types.UPDATE_CAMPAIGNS_FILTERS:
            return Object.assign({}, state, { filters: { ...state.filters, ...action.update } });
        case types.UPDATE_CAMPAIGNS_TABLE:
            return Object.assign({}, state, { campaignsTable: { ...state.campaignsTable, ...action.settings } });

        case types.START_CREATE_CAMPAIGN:
            return Object.assign({}, state, { newCampaign: { ...initialState.newCampaign, loading: true } });
        case types.CREATE_CAMPAIGN:
            return Object.assign({}, state, { newCampaign: { loading: action.response.loading, success: action.response.success, message: action.response.message, campaignId: action.response.data } });
        case types.DELETE_CAMPAIGN:
            return Object.assign({}, state, { campaignDelete: { ...action.result } });
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/redux/reducers/CampaignsReducer.js